import { FETCH_ALARM } from './actionType'

const initialState = {
    alarm: {},
  // profileData: {},
  // userLocation: DEFAULT_DATA
}
const alarmReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALARM:
      return {
        ...state,
        alarm: action.payload,
      }
    // case USER_PROFILE:
    //     return {
    //         ...state,
    //         profileData: action.payload
    //     };
    // case USER_LOCATION:
    //     return {
    //         ...state,
    //         userLocation: action.payload
    //     };
    default:
      return state
  }
}

export default alarmReducer
